import * as Yup from "yup";

export const ReportSchema = Yup.object().shape({

    type: Yup.string().required("Select Type"),
    reason: Yup.string().required("Enter a Reason"),
    start_date: Yup.string().required("Select Start Date"),
    end_date: Yup.string().required('Select End Date').test('end-date-validation',
        'End Date should not be before Start Date', function (value, context) {
            const { start_date } = context.parent;

            if (new Date(value) >= new Date(start_date)) {
                return true;
            } else {
                return false;
            }
        })
        .test('within-3-months', 'End Date must be within 3 months of Start Date', function (value, context) {
            const { start_date } = context.parent;
            const startDate = new Date(start_date);
            const endDate = new Date(value);
            const threeMonthsLater = new Date(startDate);
            threeMonthsLater.setMonth(startDate.getMonth() + 3);

            return endDate <= threeMonthsLater;
        }),
    department_wise: Yup.string().notRequired(''),
    user_wise: Yup.string().notRequired(''),
    group_wise: Yup.string().notRequired(''),
    session_wise: Yup.string().notRequired(''),
    learning_module_wise: Yup.string().notRequired(''),
    learning_track_wise: Yup.string().notRequired('')
});

export const AuditReportSchema = Yup.object().shape({

    type: Yup.string().notRequired("Select Type"),
    start_date: Yup.string().required("Select Start Date"),
    end_date: Yup.string().required('Select End Date').test('end-date-validation',
        'End Date should not be before Start Date', function (value, context) {
            const { start_date } = context.parent;

            if (new Date(value) >= new Date(start_date)) {
                return true;
            } else {
                return false;
            }
        })
        .test('within-3-months', 'End Date must be within 3 months of Start Date', function (value, context) {
            const { start_date } = context.parent;
            const startDate = new Date(start_date);
            const endDate = new Date(value);
            const threeMonthsLater = new Date(startDate);
            threeMonthsLater.setMonth(startDate.getMonth() + 3);

            return endDate <= threeMonthsLater;
        }),

    user_wise: Yup.string().when('type', {
        is: (val) => val == 1,
        then: () => Yup.string().required('Select User'),
        otherwise: () => Yup.string().notRequired('Select User'),
    }),
    learning_module_wise: Yup.string().when('type', {
        is: (val) => val == 2,
        then: () => Yup.string().required('Select Learning Module'),
        otherwise: () => Yup.string().notRequired('Select Learning Module'),
    }),
});